import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Password from "../Login/Password";
import Swal from "sweetalert2";

// ── Navegación completa (usuarios internos) ───────────────────────────────────
const NAV_FULL = [
  {
    section: "Operación",
    items: [
      { label: "Catálogos",   icon: "fas fa-box",          href: "/MenuCatalogos",   perm: "menu_articulos"   },
      { label: "Ventas",     icon: "fas fa-clipboard-list", href: "/MenuVentas",     perm: "menu_ventas"      },
      { label: "Compras",     icon: "fas fa-truck",        href: "/MenuCompras",     perm: "menu_compras"     },
      { label: "Producción",  icon: "fas fa-cut",          href: "/MenuProduccion",  perm: "menu_produccion"  },
      { label: "Inventarios", icon: "fas fa-warehouse",    href: "/MenuInventarios", perm: "menu_inventarios" },
    ],
  },
  {
    section: "Finanzas",
    items: [
      { label: "Admin",  icon: "fas fa-file-invoice-dollar", href: "/MenuAdmin", perm: "menu_admin"    },
      { label: "CxP",    icon: "fas fa-money-check-alt",     href: "/MenuCXP",   perm: "menu_adminCxP" },
      { label: "Gastos", icon: "fas fa-wallet",              href: "/MenuGastos", perm: "menu_gastos"  },
      { label: "Estadísticas", icon: "fas fa-chart-line",    href: "/Estadisticas", perm: "menu_reportes" },
    ],
  },
  {
    section: "Personal",
    items: [
      { label: "Empleados", icon: "fas fa-id-badge", href: "/MenuNominas", perm: "menu_nominas" },
    ],
  },
  {
    section: "Sistema",
    items: [
      { label: "Usuarios", icon: "fas fa-user-cog",       href: "/MenuUsuarios", perm: "menu_usuarios" },
      { label: "Logs",     icon: "fas fa-clipboard-check", href: "/MenuLogs",    perm: "menu_logs"     },
    ],
  },
];

// ── Navegación limitada (cobradores / clientes) ───────────────────────────────
const NAV_LIMITED = [
  {
    section: "Mi cuenta",
    items: [
      { label: "Abonos Facturas",  icon: "fas fa-hand-holding-usd", href: "/AbonosNotasCreate",   perm: "menu_cobradores"    },
      { label: "Estado de Cuenta", icon: "fas fa-file-alt",         href: "/EdoCtaVistaFamilias", perm: "menu_edoCta_Fam"    },
      { label: "Info Alumnos",     icon: "fas fa-user-graduate",    href: "/InfoHijos",           perm: "menu_edoCta_Fam"    },
      { label: "Estado de Cuenta", icon: "fas fa-file-alt",         href: "/EdoCtaVistaClientes", perm: "menu_edoCta_Cliente" },
    ],
  },
];

const Header = () => {
  const { isAuth, user } = useContext(AuthContext);

  const [sidebarOpen,   setSidebarOpen]   = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const [userMenuOpen,  setUserMenuOpen]  = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar-collapsed") === "true"
  );

  const currentPath = window.location.pathname;

  // ── Body classes ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (!isAuth) return;
    document.body.classList.add("has-sidebar");
    if (localStorage.getItem("sidebar-collapsed") === "true") {
      document.body.classList.add("sidebar-collapsed");
    }
    return () => {
      document.body.classList.remove("has-sidebar");
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [isAuth]); // eslint-disable-line

  if (!isAuth) return null;

  // Usuarios de portal (cobrador / cliente) usan la navegación limitada
  const isPortal = user.menu_edoCta_Cliente || user.menu_cobradores;
  const NAV_SECTIONS = isPortal ? NAV_LIMITED : NAV_FULL;

  // ── Helpers ───────────────────────────────────────────────────────────────
  const hasPerm = (perm) => !!user[perm];

  // Respaldo completo de la base (formato mongodump .tar.gz). Solo con permiso descargar_bd.
  const descargarBD = async () => {
    setUserMenuOpen(false);
    Swal.fire({
      title: "Generando respaldo...",
      text: "Puede tardar un minuto. No cierres la página.",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
    try {
      const resp = await fetch(process.env.REACT_APP_URL_RESPALDO_BD, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      if (!resp.ok) {
        const d = await resp.json().catch(() => ({}));
        throw new Error(d.message || `Error ${resp.status}`);
      }
      const blob = await resp.blob();
      const disp = resp.headers.get("Content-Disposition") || "";
      const m = disp.match(/filename="?([^"]+)"?/);
      const nombre = m ? m[1] : "respaldo_gavini.tar.gz";
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = nombre;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      Swal.fire({ icon: "success", title: "Respaldo descargado", text: nombre });
    } catch (e) {
      Swal.fire({ icon: "error", title: "No se pudo descargar", text: e.message });
    }
  };

  // Clave especial para vender abajo del precio de lista (VentaDirecta). Solo Pru/Admin.
  const cambiarClavePrecio = async () => {
    setUserMenuOpen(false);
    const r = await Swal.fire({
      title: "Clave de precio especial",
      html:
        "Es la clave que se pide en Venta Directa para vender <b>abajo del precio de lista</b> del cliente.<br/><br/>" +
        '<input id="clave1" type="password" class="swal2-input" placeholder="Nueva clave (mínimo 4)">' +
        '<input id="clave2" type="password" class="swal2-input" placeholder="Repite la clave">',
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      focusConfirm: false,
      preConfirm: () => {
        const c1 = document.getElementById("clave1").value.trim();
        const c2 = document.getElementById("clave2").value.trim();
        if (c1.length < 4) return Swal.showValidationMessage("Mínimo 4 caracteres");
        if (c1 !== c2) return Swal.showValidationMessage("Las claves no coinciden");
        return c1;
      },
    });
    if (!r.isConfirmed) return;
    try {
      const resp = await fetch(process.env.REACT_APP_URL_CLAVE_PRECIO, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
        body: JSON.stringify({ clave: r.value }),
      });
      const d = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(d.message || `Error ${resp.status}`);
      Swal.fire({ icon: "success", title: "Clave guardada" });
    } catch (e) {
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: e.message });
    }
  };

  const toggleCollapse = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem("sidebar-collapsed", next);
    if (next) {
      document.body.classList.add("sidebar-collapsed");
      setUserMenuOpen(false);
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  };

  return (
    <>
      {/* ── Mobile top bar ──────────────────────────────────────────────── */}
      <div className="sidebar-topbar d-lg-none">
        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <i className="fas fa-bars" />
        </button>
        <a href="/Inicio">
          <img src={process.env.PUBLIC_URL + "/LogoInstitucion.png"} height="34" alt="logo" />
        </a>
      </div>

      {/* ── Mobile overlay ──────────────────────────────────────────────── */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Sidebar ─────────────────────────────────────────────────────── */}
      <aside
        className={[
          "app-sidebar",
          sidebarOpen ? "open"      : "",
          collapsed   ? "collapsed" : "",
        ].filter(Boolean).join(" ")}
      >
        {/* Brand */}
        <div className="sidebar-brand">
          <a href="/Inicio" className="sidebar-logo-link">
            <img
              src={process.env.PUBLIC_URL + "/LogoInstitucion.png"}
              alt="logo"
              style={{ maxHeight: 44, width: "auto" }}
            />
          </a>
          <button
            className="sidebar-collapse-btn"
            onClick={toggleCollapse}
            title={collapsed ? "Expandir" : "Comprimir"}
          >
            <i className={`fas fa-chevron-${collapsed ? "right" : "left"}`} />
          </button>
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {NAV_SECTIONS.map((sec) => {
            const visibleItems = sec.items.filter((i) => hasPerm(i.perm));
            if (visibleItems.length === 0) return null;

            return (
              <div key={sec.section} className="sidebar-section-group">
                <div className="sidebar-section">{sec.section}</div>

                {visibleItems.map((item) => {
                  const isActive = currentPath === item.href;
                  return (
                    <a
                      key={item.href}
                      href={item.href}
                      className={`sidebar-item${isActive ? " active" : ""}`}
                      title={collapsed ? item.label : ""}
                    >
                      <i className={item.icon} />
                      <span className="sidebar-label">{item.label}</span>
                    </a>
                  );
                })}
              </div>
            );
          })}
        </nav>

        {/* User footer */}
        <div className="sidebar-footer">
          <div
            className="sidebar-item"
            onClick={() => !collapsed && setUserMenuOpen(!userMenuOpen)}
            title={collapsed ? (user.nombre || user.email || "Usuario") : ""}
            style={{ justifyContent: collapsed ? "center" : "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
              <i className="fas fa-user-circle" />
              <span className="sidebar-label" style={{ fontSize: "0.78rem" }}>
                {user.nombre || user.email || "Usuario"}
              </span>
            </div>
            {!collapsed && (
              <i className={`fas fa-chevron-${userMenuOpen ? "down" : "up"} fa-xs`} style={{ opacity: 0.5 }} />
            )}
          </div>

          {userMenuOpen && !collapsed && (
            <div className="sidebar-submenu">
              <div
                className="sidebar-item sidebar-item-sm"
                onClick={() => { setModalPassword(true); setUserMenuOpen(false); }}
              >
                <i className="fas fa-lock" />
                <span>Cambiar contraseña</span>
              </div>
              {user.descargar_bd && (
                <div className="sidebar-item sidebar-item-sm" onClick={descargarBD}>
                  <i className="fas fa-database" />
                  <span>Descargar base de datos</span>
                </div>
              )}
              {user.descargar_bd && (
                <div className="sidebar-item sidebar-item-sm" onClick={cambiarClavePrecio}>
                  <i className="fas fa-key" />
                  <span>Clave de precio especial</span>
                </div>
              )}
              <a href="/logout" className="sidebar-item sidebar-item-sm" style={{ color: "#f87171" }}>
                <i className="fas fa-sign-out-alt" />
                <span>Cerrar sesión</span>
              </a>
            </div>
          )}
        </div>
      </aside>

      {/* ── Password modal ───────────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modalPassword} toggle={() => setModalPassword(false)}>
        <ModalHeader toggle={() => setModalPassword(false)}>
          Cambio de contraseña
        </ModalHeader>
        <ModalBody>
          <Password />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Header;
